import React, { useState, useEffect } from 'react';
import { MDBTable, MDBTableHead, MDBTableBody } from 'mdb-react-ui-kit';
import './ActiveList.css';
import { getProgramData } from "../Services/Service";
import ReactPaginate from "react-paginate";
import { Link, useNavigate } from "react-router-dom";
import { checkUserAccess } from "../Services/CommonLibrary";
import {formatUkNumber} from "./Utils";
import $ from 'jquery'

function ProgramList() {

    const [serviceData, setServiceData] = useState([]);
    const [filterval, setfilterval] = useState([]);
    const [items, setItems] = useState([]);
    // let currentPage = 1;
    const [currentPage, setCurrentPage] = useState(1);
    const [pageCount, setpageCount] = useState(100);
    const [limit, setLimit] = useState(10);
    const nav = useNavigate();

    useEffect(() => {
        fetchProgramList('all', 1, limit);
    }, []);

    const fetchProgramList = async (filterEvent, currentPage, limit) => {
        //   alert("call");
        // setCurrentPage(currentPage);
        getProgramData(filterEvent, currentPage, limit)
            .then((res) => {
                let list = res?.data?.data;

                console.log("Received list:", list);

                if (!Array.isArray(list)) {
                    console.warn("API did NOT return an array. Fixing automatically.");
                    list = [];
                }
                // if(currentPage == 1){
                //     setpageCount(Math.ceil(res.data.total / limit));
                // }
                setServiceData(list);
            }
            );
        console.log("data", serviceData);
    }

    const fetchUserList = (event, programId, programName) => {
        var programDetail = { 'programId': programId, 'programName': programName };
        localStorage.setItem('programDetail', JSON.stringify(programDetail));
        let accessFrom= localStorage.getItem('access');
        
        nav(checkUserAccess());
       


        // const navLinks = document.getElementsByClassName('nav-link');
        // for (let i = 0; i < navLinks.length; i++) {
        //         navLinks[i].classList.remove('active');
        //     }
        //     const firstNavLink = document.getElementsByClassName('nav-link')[0];
        //     firstNavLink.classList.add('active');
    };

    return (
        <section className="projects-section">
            <div className="row">
                <div className="FL">
                    <div className="col-md-12 mb-4">
                        <h1 className="title mb-3">Select Program to Proceed</h1>
                        <h3 className="title-sub"></h3>
                    </div>

                    <div className="row justify-content-center">

                        {serviceData.map((data, i) => (
                            <div className="col-md-6 col-xl-4 mb-3" key={i}>
                                {/* <button to={`/program-detail/${data.programId}`}> */}
                                <button className='btn btn-100' onClick={event => fetchUserList(event, data.programId, data.programName)}>
                                    <div className="card h-100 project-box text-center project-box-bg1">
                                        {/* <img
                          src="https://appcdn.goqii.com/storeimg/82090_1672378047.png"
                          style={{
                            height: "120px",
                            width: "auto",
                            maxWidth: "fit-content",
                            margin:"0 auto"
                          }}
                          alt="..."
                        /> */}
                                        <h5 className="card-title mb-0">{data.programName} ({formatUkNumber(data.userCount)})</h5>
                                    </div>
                                </button>
                            </div>
                        ))}

                    </div>

                    {/* <MDBTable align='middle'>
                <MDBTableHead>
                    <tr className="table-head">
                        <th scope='col'>Program</th>
                    </tr>
                </MDBTableHead>
                <MDBTableBody>
                    

                </MDBTableBody>
            </MDBTable>
            <br /> */}
                    {/* <ReactPaginate
                previousLabel={"Previous"}
                nextLabel={"Next"}
                breakLabel={"..."}
                pageCount={pageCount}
                marginPagesDisplayed={2}
                pageRangeDisplayed={3}
                onPageChange={fetchList}
                containerClassName={"pagination justify-content-center"}
                pageClassName={"page-item"}
                pageLinkClassName={"page-link"}
                previousClassName={"page-item"}
                previousLinkClassName={"page-link"}
                nextClassName={"page-item"}
                nextLinkClassName={"page-link"}
                breakClassName={"page-item"}
                breakLinkClassName={"page-link"}
                activeClassName={"active"}
            /> */}
                </div>
            </div>
        </section>
    );
}
export default ProgramList;